<template>
  <div>
    <!-- 银行电子户信息 -->
    <div class="manage-card-box">
      <div class="info-card-title">
        账户信息
      </div>
      <div class="base-info-list">
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label">
              开户行名（开户支行）
            </div>
            <div class="value">
              威海蓝海银行股份有限公司
            </div>
          </div>
          <div class="item">
            <div class="label">
              联行号
            </div>
            <div class="value">
              323465000019
            </div>
          </div>

          <div class="item">
            <div class="label">
              收款户名
            </div>
            <div class="value">
              {{ data.bankElecAccounts?.[0]?.bankAccountName }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              易宝用户编号
            </div>
            <div class="value">
              {{ data.merchantNo }}
            </div>
          </div>
        </div>

        <div class="right-list">
          <div class="item">
            <div class="label">
              开户银行（行别）
            </div>
            <div class="value">
              蓝海银行
            </div>
          </div>
          <div class="item">
            <div class="label">
              收款银行城市
            </div>
            <div class="value">
              山东省-威海市
            </div>
          </div>
          <div class="item">
            <div class="label">
              收款账号
            </div>
            <div class="value">
              {{ data.bankElecAccounts?.[0]?.bankAccountNo }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              易宝账户状态
            </div>
            <div class="value">
              {{ yibaoAccountStatusLabel[data.merchantStatus] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="manage-card-box mt-5">
      <div class="info-card-title">
        使用说明
      </div>
      <div>
        <el-steps direction="vertical" :active="3">
          <el-step>
            <template #title>
              <div class="setpTit">
                确认汇款账户信息与平台店铺资质是否一致
              </div>
            </template>
            <template #description>
              <div>
                <p class="text-[#95A0B6]">
                  请先确认汇款账户信息与平台店铺资质是否一致，以及平台是否允许绑定非平台资质的收款账户，防止绑定失败或提现被拦截；
                </p>
                <div
                  class="bg-[#f5f6fa] text-[#344767] p-[10px] rounded-[2px] mb-4  mt-2"
                >
                  <span class="text-[#95A0B6]">
                    收款户名</span>  {{ data.bankElecAccounts?.[0]?.bankAccountName }}
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="setpTit">
                绑定收款账户
              </div>
            </template>
            <template #description>
              <div>
                <p class="text-[#95A0B6] mb-2">
                  请按照申请的账户信息进行填写，关键信息可直接复制；
                </p>
                <div
                  class="bg-[#f5f6fa] text-[#344767] p-[10px] rounded-[2px]  flex "
                >
                  <div class="flex-1">
                    <div>
                      <span class="text-[#95A0B6]">
                        收款账户</span>

                      {{ data.bankElecAccounts?.[0]?.bankAccountNo }}
                      <svg-icon icon="tabler:box-multiple" class="main-primary-text !w-[16px] cursor-pointer" style="vertical-align: -5px;" @click="copy(data.bankElecAccounts?.[0]?.bankAccountNo)" />
                    </div>
                  </div>
                  <div class="flex-1">
                    <span class="text-[#95A0B6]">
                      收款户名</span>

                    {{ data.name }}
                    <svg-icon icon="tabler:box-multiple" class="main-primary-text !w-[16px] cursor-pointer" style="vertical-align: -5px;" @click="copy(data.name)" />
                  </div>
                </div>
                <div
                  class="bg-[#f5f6fa] text-[#344767] p-[10px] pt-0 rounded-[2px]  flex "
                >
                  <div class="flex-1">
                    <div>
                      <span class="text-[#95A0B6]">
                        开户银行</span>

                      蓝海银行
                      <svg-icon icon="tabler:box-multiple" class="main-primary-text !w-[16px] cursor-pointer" style="vertical-align: -5px;" @click="copy('蓝海银行')" />
                    </div>
                  </div>
                  <div class="flex-1">
                    <span class="text-[#95A0B6]">
                      开户行名（开户支行）</span>

                    威海蓝海银行股份有限公司
                    <svg-icon icon="tabler:box-multiple" class="main-primary-text !w-[16px] cursor-pointer" style="vertical-align: -5px;" @click="copy('威海蓝海银行股份有限公司')" />
                  </div>
                </div>
                <div
                  class="bg-[#f5f6fa] text-[#344767] p-[10px] pt-0 rounded-[2px]  flex "
                >
                  <div class="flex-1">
                    <div>
                      <span class="text-[#95A0B6]">
                        联行号</span>

                      323465000019
                      <svg-icon icon="tabler:box-multiple" class="main-primary-text !w-[16px] cursor-pointer" style="vertical-align: -5px;" @click="copy('323465000019')" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="setpTit mt-4">
                发起提现并等待入账
              </div>
            </template>
            <template #description>
              <div>
                <p class="text-[#95A0B6] ">
                  收款账户绑定成功后，可以在平台中发起提现，提现的金额将会在开户行进行处理入账；
                </p>
                <p class="text-[#F56C6C]">
                  注意
                </p>
                <div class="mt-4">
                  <img v-if="data.bankElecAccounts?.[0]?.bankCode == 'WHLHB'" class="w-[529px] " src="@core/main/assets/images/yibao-WHLHB-tips.png" alt="">
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { SvgIcon } from '@vue3/components';
import { useClipboard } from '@vueuse/core';
import { IYibaoDetail, yibaoAccountStatusLabel } from '../../../../types/yibao';

defineOptions({ name: 'BankElectronicAccount' });

defineProps({
  data: {
    type: Object as PropType<IYibaoDetail>,
    default() {
      return {} as IYibaoDetail;
    },
  },
});

const { copy } = useClipboard();

</script>

<style lang="scss" scoped>
.info-btns {
  position: absolute;
  top: 26px;
  right: 24px;
}

.right-list {
  .label {
    width: 140px !important;
  }
}

.left-list {
  .label {
    width: 140px !important;
  }
}

:deep(.el-step__head){
  color: #fff;
  border-color: #fff;

}

:deep(.el-step__icon-inner){
  color: #fff;
}

:deep(.el-step__line){
    background-color: var(--color-primary);
    width: 3px !important;
  }

:deep(.el-step__icon,.is-text){
  background-color: var(--color-primary);
  font-size: 10px;
}

.setpTit{
  color: #344767;
  font-size: 14px;
}

</style>
